import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  onUserBalance,
  onUserMyTransaction,
  onUserReloadBalance,
} from "../../../redux/homeAction";
import Banner from "../../Banner/Banner";
import Footer from "../../Footer/Footer";
import Loader from "../../loader/Loader";
import ReloadModel from "../../Models/ReloadModel/ReloadModel";
import WithDrawModel from "../../Models/WithDrawModel/WithDrawModel";
import Navbar from "../../Navbar/Navbar";
import Profile from "../Profile/Profile";
import Pagination from "../../Pagination/Pagination";

const Wallet = () => {
  const dispatch = useDispatch();
  const classSend = "position-relative";
  const [addClass, setAddClass] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showPerPage, setShowPerPage] = useState(1);
  const getUserReloadBalance = useSelector(
    (state) => state.home.getUserReloadBalance
  );
  const getUserBalance = useSelector((state) => state.home.getUserBalance);
  const getUserMyTransaction = useSelector(
    (state) => state.home.getUserMyTransaction
  );
  const userDeatils = JSON.parse(localStorage.getItem("userDetails"));

  const reloadBalance = () => {
    const data = {
      user_id: userDeatils && userDeatils.user_id,
    };
    dispatch(onUserReloadBalance(data));
  };

  useEffect(() => {
    setLoader(true);
    const data = {
      user_id: userDeatils && userDeatils.user_id,
    };
    console.log('Fetching transactions for user:', data);
    dispatch(onUserMyTransaction(data, setLoader));
    dispatch(onUserBalance(data));
  }, [getUserReloadBalance]);

  // Add this to check the data structure
  console.log('Transaction data:', getUserMyTransaction);

  const transactions = getUserMyTransaction?.data || [];
  const lastPostIndex = showPerPage * 10;
  const firstPostIndex = lastPostIndex - 10;
  const currentPost = transactions.slice(firstPostIndex, lastPostIndex);

  return (
    <>
      <Navbar classSend={classSend} />
      <Profile />
      <section id="Tabs_section">
        <div className="container">
          <div className="tabs_container">
            <div className="tabs_nav">
              <ul id="tabs">
                {/* <li>
                  <div>
                    <NavLink to="/dashboard-profile">Wall</NavLink>
                  </div>
                </li>
                <li>
                  <div>
                    <NavLink to="/dashboard-notification">notification</NavLink>
                  </div>
                </li> */}
                <li className={`${addClass ? "active_tab" : ""} `}>
                  <div>
                    <NavLink
                      to="/dashboard-my-wallet"
                      className={({ isActive }) => {
                        setAddClass(isActive);
                      }}
                    >
                      my wallet
                    </NavLink>
                  </div>
                </li>
                <li>
                  <div>
                    <NavLink to="/dashboard-my-bets/?path=bet">my bets</NavLink>
                  </div>
                </li>
                {/* <li>
                  <div>
                    <NavLink to="/dashboard-friend-referrelas">
                      friends &amp; referrelas
                    </NavLink>
                  </div>
                </li>
                <li>
                  <div>
                    <NavLink to="/dashboard-setting">settings</NavLink>
                  </div>
                </li> */}
              </ul>
            </div>
          </div>
          <div className="tebs_content">
            <div className="tabs_section" id="wallet">
              <div className="theWall">
                <h1>
                  My <span className="color_yellow">Wallet</span>
                </h1>
                <div className="wallet_profile">
                  <div className="row justify-content-between gy-3">
                    <div className="col-md-4">
                      <div className="wallet_profiler_detail" style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',height:'100%'}}>
                        <div>
                          <h1>{userDeatils && userDeatils.full_name}</h1>
                          <img
                            src="./images/profile_dots.png"
                            className="img-fluid profile_dots"
                          />
                          <p style={{color:'#ffe0b2',marginBottom:0}}>Balance</p>
                          <h2 className={` ${getUserBalance && getUserBalance.total_balance.toString().length > 6 ? "active" : ""}`}>{getUserBalance && getUserBalance.total_balance}</h2>
                          <div className="available_balance" style={{color:'#fff',fontWeight:600,fontSize:'18px'}}>Available: <span>{getUserBalance && getUserBalance.balance}</span></div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="wallet_proflie_boxs">
                        <div className="wallet_profile_box">
                          <img
                            src="./images/PTS.png"
                            className="img-fluid wallet_proflie_boxs_img"
                          />
                          <p>PTS</p>
                          <h2
                            className={` ${
                              getUserBalance &&
                              getUserBalance.total_balance.toString().length > 6
                                ? "active"
                                : ""
                            }`}
                          >
                            {getUserBalance && getUserBalance.total_balance}
                          </h2>
                        </div>
                        <div className="wallet_profile_box">
                          <img
                            src="./images/USD.png"
                            className="img-fluid wallet_proflie_boxs_img"
                          />
                          <p>USD</p>
                          <h2
                            className={` ${
                              getUserBalance &&
                              getUserBalance.balance.toString().length > 6
                                ? "active"
                                : ""
                            }`}
                          >
                            {getUserBalance && getUserBalance.usd}
                          </h2>
                        </div>
                        <div className="wallet_profile_box">
                          <img
                            src="./images/BTC.png"
                            className="img-fluid wallet_proflie_boxs_img"
                          />
                          <p>BTC</p>
                          <h2
                            className={` ${
                              getUserBalance &&
                              getUserBalance.balance.toString().length > 6
                                ? "active"
                                : ""
                            }`}
                          >
                            {getUserBalance && getUserBalance.btc ? getUserBalance.btc : "-"}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                 {/*<div className="add_post_btn text-center Withdraw_row">
                  {getUserBalance && getUserBalance.balance < 8000 ? (
                    <button
                      className="btn post_btn btnFill"
                      data-bs-toggle="modal"
                      data-bs-target="#reloadRequest"
                      onClick={reloadBalance}
                    >
                      <div className="btnfilltext">
                        <svg
                          className="withdraw_icon"
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 8C13.976 8 18 6.626 18 4C18 1.374 13.976 0 10 0C6.024 0 2 1.374 2 4C2 6.626 6.024 8 10 8Z"
                            fill="#FF6A0D"
                          />
                          <path
                            d="M2 8C2 10.626 6.024 12 10 12C13.976 12 18 10.626 18 8V6C18 8.626 13.976 10 10 10C6.024 10 2 8.626 2 6V8Z"
                            fill="#FF6A0D"
                          />
                          <path
                            d="M2 12C2 14.626 6.024 16 10 16C13.976 16 18 14.626 18 12V10C18 12.626 13.976 14 10 14C6.024 14 2 12.626 2 10V12Z"
                            fill="#FF6A0D"
                          />
                          <path
                            d="M2 16C2 18.626 6.024 20 10 20C13.976 20 18 18.626 18 16V14C18 16.626 13.976 18 10 18C6.024 18 2 16.626 2 14V16Z"
                            fill="#FF6A0D"
                          />
                        </svg>
                        Reload
                      </div>
                    </button>
                  ) : (
                    <button
                      className="btn post_btn btnFill"
                      data-bs-toggle="modal"
                      data-bs-target="#reloadRequest"
                      disabled
                    >
                      <div className="btnfilltext">
                        <svg
                          className="withdraw_icon"
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 8C13.976 8 18 6.626 18 4C18 1.374 13.976 0 10 0C6.024 0 2 1.374 2 4C2 6.626 6.024 8 10 8Z"
                            fill="#FF6A0D"
                          />
                          <path
                            d="M2 8C2 10.626 6.024 12 10 12C13.976 12 18 10.626 18 8V6C18 8.626 13.976 10 10 10C6.024 10 2 8.626 2 6V8Z"
                            fill="#FF6A0D"
                          />
                          <path
                            d="M2 12C2 14.626 6.024 16 10 16C13.976 16 18 14.626 18 12V10C18 12.626 13.976 14 10 14C6.024 14 2 12.626 2 10V12Z"
                            fill="#FF6A0D"
                          />
                          <path
                            d="M2 16C2 18.626 6.024 20 10 20C13.976 20 18 18.626 18 16V14C18 16.626 13.976 18 10 18C6.024 18 2 16.626 2 14V16Z"
                            fill="#FF6A0D"
                          />
                        </svg>
                        Reload
                      </div>
                    </button>
                  )}
                </div> */}
                {loader ? (
                  <div className="text-center mt-4 mb-4">
                    <Loader />
                  </div>
                ) : (
                  <div className="recent_transitions">
                    <div className="recent_transition d-flex justify-content-between">
                      <h5>Recent Transactions</h5>
                      {/* <p>View All</p> */}
                    </div>
                    <div className="transition_table">
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Description</th>
                              <th scope="col">Amount</th>
                              <th scope="col">Type</th>
                              <th scope="col">Previous Balance</th>
                              <th scope="col">New Balance</th>
                            </tr>
                          </thead>
                          {currentPost.length > 0 ? (
                            <tbody>
                              {currentPost.map((data, i) => (
                                <tr key={i}>
                                  <td>{moment(data.created_at).format("MMM DD, LT")}</td>
                                  <td>{data.description}</td>
                                  <td>{parseFloat(data.amount).toFixed(2)}</td>
                                  <td className={`value_${data.type === 'credit' ? 'up' : 'down'}`}>
                                    <i className={`fa-solid fa-arrow-${data.type === 'credit' ? 'up' : 'down'}`} />{' '}
                                    {data.type}
                                  </td>
                                  <td>{parseFloat(data.previous_balance || 0).toFixed(2)}</td>
                                  <td>{parseFloat(data.new_balance || 0).toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>
                          ) : (
                            <tbody>
                              <tr>
                                <td colSpan="6">
                                  <h2 className="text-center mt-3 mb-3">No Data Found</h2>
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </table>
                        <Pagination
                          setShowPerPage={setShowPerPage}
                          showPerPage={showPerPage}
                          totalPosts={transactions.length}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <Banner />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />

      {/* <WithDrawModel /> */}
      {/* <ReloadModel /> */}
    </>
  );
};

export default Wallet;
